import React, { useState, useEffect } from "react";
import DashboardLayout from '../layouts/DashboardLayout'
import EsriFooter from '../components/EsriFooter'
import DashboardHeader from '../components/DashboardHeader'
import { NavLink } from 'react-router-dom'
import Button from '../components/Button'
import { useGet } from "../libs/service/api";
const ParticipateInWorkshop = props => {
    const [events, seEvents] = useState([])
    const GetEvents = () => {
        return useGet("/commonapi/events").then(res => {
            seEvents(res.Data.Table)
        });
    }
    const CallRegister = (url) => {
        window.open(url, "_blank")
    }
    useEffect(() => {
        GetEvents()
    }, []);
    return (
        <DashboardLayout hideAccountDropdown={true}>
            <DashboardHeader title="Connect with us">
                <NavLink to="/connect/contact-us" className="mx-3 xl:mx-8" activeClassName="font-bold text-primary">Contact Us</NavLink>
                <NavLink to="/connect/feedback" className="mx-3 xl:mx-8" activeClassName="font-bold text-primary">Feedback</NavLink>
                <NavLink to="/connect/participate-in-workshop" className="mx-3 xl:mx-8" activeClassName="font-bold text-primary">Participate in Workshop</NavLink>
            </DashboardHeader>
            <div className="mt-12">
                <h2 className="text-xle font-bold mb-1">Participate in workshops</h2>
                <p>No upcoming workshops</p>

                <div className="flex flex-wrap mt-6">

                    {
                        events && events.length > 0 && events.map((item, index, array) => {
                            return <div className="w-2/4 pr-4.5 pb-4.5 3xl:w-1/3">
                                <div className="border border-primary bg-primary-light bg-opacity-30 rounded-lg p-4">
                                    <h3 className="text-xle font-bold mb-1 text-primary">{item.tittle}</h3>
                                    <div className="font-bold">{item.eventdate}</div>
                                    <p className="mt-3">{item.descriptions}</p>
                                    <div className="flex justify-center mt-6"><Button btnStyle="primary" text="Register here" extraClasses="px-10" onClick={() => CallRegister(item.url)} /></div>
                                </div>
                            </div>
                        })}


                    {/* <div className="w-2/4 pr-2.5 pb-2.5">
                <div className="border border-primary bg-primary-light bg-opacity-30 rounded-lg p-4">
                <h3 className="text-xle font-bold mb-1 text-primary">Urban Workshop</h3>
                <div className="font-bold">21 Jan 2021</div>
                <p className="mt-3">rem ipsum dolor sit amet, consectetur adipiscing elit. Duis vel cursus magna. Nulla imperdiet, arcu eu tempus tristique.rem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                <div className="flex justify-center mt-6"><Button btnStyle="primary" text="Register here" extraClasses="px-10" /></div>
                </div>
                </div>
                <div className="w-2/4 pl-2.5 pb-2.5">
                <div className="border border-primary bg-primary-light bg-opacity-30 rounded-lg p-4">
                <h3 className="text-xle font-bold mb-1 text-primary">Urban Workshop</h3>
                <div className="font-bold">21 Jan 2021</div>
                <p className="mt-3">rem ipsum dolor sit amet, consectetur adipiscing elit. Duis vel cursus magna. Nulla imperdiet, arcu eu tempus tristique.rem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                <div className="flex justify-center mt-6"><Button btnStyle="primary" text="Register here" extraClasses="px-10" /></div>
                </div>
                </div>
                <div className="w-2/4 pr-2.5 pt-2.5">
                <div className="border border-primary bg-primary-light bg-opacity-30 rounded-lg p-4">
                <h3 className="text-xle font-bold mb-1 text-primary">Urban Workshop</h3>
                <div className="font-bold">21 Jan 2021</div>
                <p className="mt-3">rem ipsum dolor sit amet, consectetur adipiscing elit. Duis vel cursus magna. Nulla imperdiet, arcu eu tempus tristique.rem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                <div className="flex justify-center mt-6"><Button btnStyle="primary" text="Register here" extraClasses="px-10" /></div>
                </div>
                </div>
                <div className="w-2/4 pl-2.5 pt-2.5">
                <div className="border border-primary bg-primary-light bg-opacity-30 rounded-lg p-4">
                <h3 className="text-xle font-bold mb-1 text-primary">Urban Workshop</h3>
                <div className="font-bold">21 Jan 2021</div>
                <p className="mt-3">rem ipsum dolor sit amet, consectetur adipiscing elit. Duis vel cursus magna. Nulla imperdiet, arcu eu tempus tristique.rem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                <div className="flex justify-center mt-6"><Button btnStyle="primary" text="Register here" extraClasses="px-10" /></div>
                </div>
                </div> */}
                </div>
            </div>

            <EsriFooter />
        </DashboardLayout>
    )
}


export default ParticipateInWorkshop
